// Dependencies

import React from 'react';

import classnames from 'classnames';
import PropTypes from 'prop-types';

// CSS
require('./simple-bar-chart.less');

class SimpleBarChart extends React.Component {
  getBarCharBarsContainerStyle() {
    const { value, max, delta } = this.props;
    const labelWidth = !this.props.label ? 0 : this.props.labelWidth;
    const ratio = delta > 0 ? (value + delta) / max : value / max;

    return {
      width: `calc((100% - ${labelWidth}px) * ${ratio})`,
    };
  }

  getAdditionalBarChartBar() {
    const { value, delta } = this.props;

    if (delta === undefined || delta === 0) {
      return null;
    }

    const deltaWidthPercent = 100 * (Math.abs(delta) / value);
    const barWidth = delta > 0 ? deltaWidthPercent : 100 - deltaWidthPercent;

    return (
      <div
        ref={(ref) => {
          this.bar = ref;
        }}
        className="simple-bar-chart-bar"
        style={{ width: `${barWidth}%` }}
      />
    );
  }

  renderBarChartbars() {
    const delta = this.props.delta;

    const classes = classnames('simple-bar-chart-bars', {
      stacked: delta > 0,
      overlay: delta < 0,
    });

    return (
      <div className={classes} style={this.getBarCharBarsContainerStyle()}>
        <div
          ref={(ref) => {
            this.bar = ref;
          }}
          className="simple-bar-chart-bar"
          style={{ width: '100%' }}
        />
        {this.getAdditionalBarChartBar()}
      </div>
    );
  }

  renderLabel() {
    if (!this.props.label) {
      return null;
    }

    return (
      <div
        className="simple-bar-chart-label"
        style={{ width: `${this.props.labelWidth}px` }}
      >
        {this.props.label}
      </div>
    );
  }

  render() {
    return (
      <div className={classnames('simple-bar-chart', this.props.className)}>
        {this.renderBarChartbars()}
        {this.renderLabel()}
      </div>
    );
  }
}

// eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration
SimpleBarChart.displayName = 'SimpleBarChart';

// eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration
SimpleBarChart.propTypes = {
  className: PropTypes.string,
  delta: PropTypes.number,
  label: PropTypes.string,
  labelWidth: PropTypes.number,
  max: PropTypes.number.isRequired,
  value: PropTypes.any.isRequired,
};

// eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration
SimpleBarChart.defaultProps = {
  delta: 0,
  className: null,
  labelWidth: 60,
  label: null,
};

export default SimpleBarChart;
